import { subclientEntity } from "../../domain/entities/subclient_entity";
import http from "../../../../plugins/http-common"
// import i18n from "../../../../i18n";

export const HttpSubclientRepository = {
  model_index: subclientEntity,

  async index_sublcients(client_id) {
    const res = await http.get('api/shipping_guides/subclients/index?client_id=' + client_id);

    return res;
  }
};